var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordInvisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons for Input",
    clipPath: "url(#clip0_2912_45109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.28648 3.60582C7.55742 3.56576 7.83692 3.54427 8.12479 3.54427C11.5281 3.54427 13.7614 6.5475 14.5116 7.73549C14.6025 7.87927 14.6479 7.95117 14.6733 8.06205C14.6923 8.14533 14.6923 8.27671 14.6732 8.35999C14.6478 8.47087 14.6021 8.54324 14.5106 8.68798C14.3107 9.00437 14.006 9.44901 13.6022 9.93124M4.60739 4.68763C3.16601 5.6654 2.18748 7.02386 1.73858 7.73446C1.64737 7.87885 1.60176 7.95105 1.57634 8.06193C1.55724 8.1452 1.55724 8.27657 1.57632 8.35984C1.60173 8.47072 1.64713 8.54261 1.73793 8.68639C2.48821 9.87438 4.72145 12.8776 8.12479 12.8776C9.49706 12.8776 10.6791 12.3893 11.6504 11.7287M2.12479 2.21094L14.1248 14.2109M6.71058 6.79672C6.34865 7.15865 6.12479 7.65865 6.12479 8.21094C6.12479 9.31551 7.02022 10.2109 8.12479 10.2109C8.67707 10.2109 9.17707 9.98708 9.539 9.62515",
    stroke: "#6C737F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2912_45109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.124512 0.210938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordInvisible);
export default __webpack_public_path__ + "static/media/PasswordInvisible.a8a775a156daffafa58f7dfa2f12edbb.svg";
export { ForwardRef as ReactComponent };